module.exports = __webpack_public_path__ + "static/img/foot_logo.cfffebc2.png";